var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resolvedTag,_vm._g(_vm._b({tag:"component",staticClass:"play-list-item",class:[
    ("play-list-item--" + _vm.variant),
    {
      'play-list-item--action': _vm.isAction,
      'is-active': _vm.active,
      'is-disabled': _vm.disabled,
    } ],attrs:{"href":_vm.resolvedTag === 'a' ? (_vm.href || null) : null,"to":_vm.resolvedTag === 'router-link' ? _vm.to : null,"type":_vm.resolvedTag === 'button' ? 'button' : null,"disabled":_vm.resolvedTag === 'button' ? _vm.disabled : null,"aria-current":_vm.active ? 'true' : null,"aria-disabled":_vm.disabled ? 'true' : null}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }